import { ComponentProps } from 'react';
import { Image } from 'react-native';

import StoreIconSvg from '../assets/ic-badge-store.svg';
import VerifiedIconSvg from '../assets/ic-badge-verified.svg';

export type BadgeProps = { size?: number; color: string } & ComponentProps<
  typeof Image
>;

export const Badge = ({ size = 16, style, ...props }: BadgeProps) => (
  <Image {...props} style={[{ width: size, height: size }, style]} />
);

export const VerifiedBadge = ({
  size = 16,
  color,
  ...props
}: Omit<BadgeProps, 'source'>) => {
  return <VerifiedIconSvg width={size} height={size} fill={color} {...props} />;
};

export const StoreBadge = ({
  size = 16,
  color,
  ...props
}: Omit<BadgeProps, 'source'>) => {
  return <StoreIconSvg width={size} height={size} fill={color} {...props} />;
};
